import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ReturnDashboardItemsPayload } from "src/app/models/dashboard/return-dashboard-items-payload";
import { DashboardService } from "src/app/services/dashboard/dashboard.service";

@Injectable()
export class DefaultDashboardItemsResolver  {

    constructor(private dashboardService: DashboardService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ReturnDashboardItemsPayload>> {
        const response = this.dashboardService.getDefaultDashboardItems()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload;
                }
                else {
                    return <ReturnDashboardItemsPayload>{
                        dashboardItems: []
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ReturnDashboardItemsPayload>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}